import { createContext, useContext, useState } from 'react';

const ChatMessagesContext = createContext();

export const useChatMessages = () => {
  return useContext(ChatMessagesContext);
};

export const ChatMessagesProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [streamingMessage, setStreamingMessage] = useState(null);

  return (
    <ChatMessagesContext.Provider
      value={{
        loading,
        messages,
        setLoading,
        setMessages,
        streamingMessage,
        setStreamingMessage,
      }}
    >
      {children}
    </ChatMessagesContext.Provider>
  );
};

export const useChatMessagesContext = () => {
  const values = useContext(ChatMessagesContext);

  return values;
};
